import React from "react";
import { createKeyboardShortcut } from "utils/keyboardShortcuts";
import Tooltip from "components/Tooltip";
import classes from "./style.module.scss";

export default ({ options = [], className, open = false, selected, toggleOpen, style }) => {
    return (
        <div style={style} className={`${classes.dropDown} ${open && classes.open} ${className && className}`}>
            <ul>
                {options.map(
                    (
                        {
                            icon,
                            label,
                            onClick,
                            className,
                            disabled,
                            tipId,
                            tip = null,
                            hasDivider = false,
                            shouldShow = true,
                            append = null,
                        },
                        index
                    ) => {
                        const classNames = [
                            className && className,
                            classes.option,
                            selected === label && classes.selected,
                            disabled && classes.disabled,
                            hasDivider && classes.hasDivider,
                            icon && classes.hasIcon,
                        ].filter((c) => c);

                        const Icon = icon ? <img src={icon} alt={label} /> : null;

                        return shouldShow ? (
                            <li
                                data-for={`dropdown-${tipId}`}
                                data-tip={tip ? `<span style="display:block; max-width:16rem;">${tip}</span>` : null}
                                data-html
                                className={classNames.join(" ")}
                                key={index}
                                onClick={disabled ? () => { } : onClick}
                                {...createKeyboardShortcut({
                                    onKeyDown: (e) => {
                                        if (!disabled) {
                                            onClick(e);
                                        }
                                    },
                                    dropDownNavigation: true
                                })}
                            >
                                {Icon}
                                {label}
                                {append}
                            </li>
                        ) : null;
                    }
                )}
            </ul>
            {options.map(
                ({ tipId }, index) => tipId && <Tooltip key={`tip-${index}`} id={`dropdown-${tipId}`} delay />
            )}
        </div>
    );
};
